import { render, staticRenderFns } from "./NestedDraggable.vue?vue&type=template&id=1a65b376&scoped=true&lang=pug&"
import script from "./NestedDraggable.vue?vue&type=script&lang=ts&"
export * from "./NestedDraggable.vue?vue&type=script&lang=ts&"
import style0 from "./NestedDraggable.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./NestedDraggable.vue?vue&type=style&index=1&id=1a65b376&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a65b376",
  null
  
)

export default component.exports